var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg048LeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9999 10.9999H5.40994L10.7099 5.70994C11.1021 5.31782 11.1021 4.68206 10.7099 4.28994C10.3178 3.89782 9.68206 3.89782 9.28994 4.28994L2.28994 11.2899C2.10063 11.4777 1.99414 11.7333 1.99414 11.9999C1.99414 12.2666 2.10063 12.5222 2.28994 12.7099L9.28994 19.7099C9.47771 19.8993 9.7333 20.0057 9.99994 20.0057C10.2666 20.0057 10.5222 19.8993 10.7099 19.7099C10.8993 19.5222 11.0057 19.2666 11.0057 18.9999C11.0057 18.7333 10.8993 18.4777 10.7099 18.2899L5.40994 12.9999H20.9999C21.5522 12.9999 21.9999 12.5522 21.9999 11.9999C21.9999 11.4477 21.5522 10.9999 20.9999 10.9999Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg048LeftArrow);
export default __webpack_public_path__ + "static/media/048-left-arrow.031798a5841bda42c9bb31e5eef962ba.svg";
export { ForwardRef as ReactComponent };